import qs from 'qs'
import moment from 'moment'
import { request } from 'meinian-package/src/utils'
import { getMeinianFilters } from 'common/localData'
import { INDUSTRY_VALUE } from 'meinian-package/src/component/enum'
import { PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'

export const pushQuery = (param) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const newQuery = { ...query, ...param }
  window.history.pushState('', '', `?${qs.stringify(newQuery)}`)
}

export const replaceQuery = (param) => {
  window.history.pushState('', '', `?${qs.stringify(param)}`)
}

export function getIndustry(gender) {
  return INDUSTRY_VALUE[gender]
}

const findItemByValue = (_value, options) => {
  const item = options.find((m) => m.name === _value)
  if (item) return item
  for (const child of options) {
    const childItem = findItemByValue(_value, child.children || child.itemTreeValue.children)
    if (childItem) return childItem
  }
}
export const getMatrix = (_value, options) => {
  if (!_value) return
  const item = findItemByValue(_value, options.itemTreeValue.children)
  if (item?.children && item?.children.length) {
    return item.children.map((m) => m.name)
  }
  return [_value]
}

const getElement = ({ child, root }, type, options) => {
  if (!child && !root) return
  const martix = []
  if (child) {
    // 选中二级
    martix.push(child)
  } else if (root) {
    // 选中一级
    const rootOption = options?.find((m) => m.itemName === type).itemTreeValue.children?.find((m) => m.name === root)
    if (rootOption?.children?.length > 0) {
      martix.push(...rootOption.children.map((m) => m.name)) // 有二级
    } else {
      martix.push(root) // 没有二级
    }
  }
  return martix
}

export const convertParams = (value = {}) => {
  const params = { labelMatrix: [] }
  const filters = getMeinianFilters()
  if (value.category && filters.length) {
    const matrix = getMatrix(
      value.category,
      filters.find((m) => m.itemName === '品类')
    )
    params.labelMatrix = [...params.labelMatrix, matrix]
  }
  if (value.bloggerTags) {
    params.bloggerTags = [value.bloggerTags]
  }
  if (value.element && value.gender && filters.length) {
    for (const key in value.element) {
      const matrix = getElement(
        value.element[key],
        key,
        filters.find((m) => m.itemName === `${getIndustry(value.gender)}设计要素`).itemTreeValue.children
      )
      params.labelMatrix = [...params.labelMatrix, matrix]
    }
  }
  if (value.cityList && filters.length) {
    params.cityList = getMatrix(
      value.cityList,
      filters.find((m) => m.itemName === '秀场')
    )
  }
  if (value.platformId && value.platformId != PLATFORM_VALUE.UPLOAD) {
    delete params.materialsFlag
  }
  return { ...value, ...params }
}

export const onChangePlatformId = (params) => {
  delete params.season
  delete params.bloggerTags
  delete params.element
  delete params.cityList
  delete params.marketName
  delete params.city
  delete params.selfCollectStatus
  delete params.blogTimeStart
  delete params.blogTimeEnd
  delete params.category
  delete params.shopType
  delete params.uploadUserList
  delete params.materialsFlag
  return { ...params }
}
export const onChangeGender = (params) => {
  if (!params.gender) {
    return onChangePlatformId(params)
  }
  delete params.element
  delete params.cityList
  delete params.category
  return { ...params }
}

export const generateParamsLength = (params = {}, exceptKeys = []) => {
  const keys = Object.keys(params).filter((m) => !exceptKeys.includes(m))
  let length = 0
  for (const key of keys) {
    if (params[key] instanceof Array) {
      params[key].length && length++
      // eslint-disable-next-line no-continue
      continue
    }
    (params[key] || params[key] === 0) && length++
  }
  return length
}

export const deleteEmptyKey = (params = {}) => {
  const keys = Object.keys(params)
  for (const index in keys) {
    !params[keys[index]] && params[keys[index]] !== 0 && keys.splice(index, 1)
  }
  return keys
}

export const formatTime = (time, format) => {
  if (!time) return null
  return moment(time).format(format || 'YYYY/MM/DD HH:mm:ss')
}

export async function getXhsUrl(id) {
  try {
    const res = await request.get('/zhikuan/xhs/temporary-token/get', {
      params: { blogId: id },
      isDirectReturn: true,
    })
    return `https://www.xiaohongshu.com/explore/${id}?xsec_token=${res}&xsec_source=pc_feed&source=xhs_sec_server`
  } catch (error) {
    console.error('temporary-token/get', error)
    return `https://www.xiaohongshu.com/explore/${id}?xsec_source=pc_feed&source=xhs_sec_server`
  }
}
